<template>
  <div class="wrraper product-details-magic-page">
    <Breadcrumb :items="items" />
    <MainLoader v-if="loading"></MainLoader>
    <div class="magic-product-container mt-5" v-else>
      <div class="row">
        <!-- Magic Image Showcase -->
        <div class="col-lg-5 col-md-6 mb-5">
          <div class="magic-image-showcase">
            <div class="glow-ring"></div>
            <vue-slick
              ref="c1"
              :asNavFor="c2"
              :focusOnSelect="true"
              :slidesToShow="1"
              :dots="true"
              :draggable="true"
              :arrows="false"
              @beforeChange="syncSliderBehavior"
              class="magic-slider"
            >
              <div v-for="image in [allData?.image]" :key="image">
                <img
                  :src="image"
                  v-if="image"
                  @error="replaceImage"
                  class="magic-product-img"
                />
              </div>
            </vue-slick>
          </div>
        </div>

        <!-- Magic Product Info -->
        <div class="col-lg-7 col-md-6">
          <div class="magic-info-wrapper" v-if="allData">
            <!-- Header -->
            <div class="magic-product-header">
              <h1 class="product-title">{{ allData.name }}</h1>
              <span
                class="magic-status-badge"
                :class="allData.is_active ? 'status-active' : 'status-inactive'"
              >
                <i
                  :class="
                    allData.is_active
                      ? 'fal fa-check-circle'
                      : 'fal fa-times-circle'
                  "
                ></i>
                {{ allData.is_active ? "مفعل" : "غير مفعل" }}
              </span>
            </div>

            <!-- Quick Stats / Info Cards -->
            <div class="magic-stats-grid mt-4">
              <!-- Category -->
              <div class="magic-stat-card">
                <div class="stat-icon-wrapper purple-gradient">
                  <i class="fal fa-list-alt"></i>
                </div>
                <div class="stat-content">
                  <span class="stat-label">التصنيف</span>
                  <h4 class="stat-value">{{ allData.menu?.name || "---" }}</h4>
                </div>
              </div>

              <!-- Store Type -->
              <div class="magic-stat-card">
                <div class="stat-icon-wrapper orange-gradient">
                  <i class="fal fa-store"></i>
                </div>
                <div class="stat-content">
                  <span class="stat-label">نوع المتجر</span>
                  <h4 class="stat-value">
                    {{ allData.place_categeory?.name || "---" }}
                  </h4>
                </div>
              </div>

              <!-- Store Name -->
              <div class="magic-stat-card">
                <div class="stat-icon-wrapper blue-gradient">
                  <i class="fal fa-map-marker-alt"></i>
                </div>
                <div class="stat-content">
                  <span class="stat-label">المتجر</span>
                  <h4 class="stat-value">{{ allData.place?.name || "---" }}</h4>
                </div>
              </div>
            </div>

            <!-- Description -->
            <div class="magic-desc-card mt-4">
              <div class="desc-header">
                <i class="fal fa-info-circle text-primary ml-2"></i>
                <span>وصف المنتج</span>
              </div>
              <p class="desc-text">{{ allData.ar?.desc || "لا يوجد وصف" }}</p>
            </div>

            <!-- Prices and Sizes -->
            <div
              class="magic-table-section mt-5"
              v-if="allData.sizes && allData.sizes.length"
            >
              <div class="section-title">
                <i class="fal fa-tags ml-2"></i> أحجام وأسعار المنتج
              </div>
              <div class="magic-table-wrapper">
                <v-data-table
                  class="elevation-0 magic-table"
                  :headers="headers"
                  :items="allData.sizes"
                  :loading="loading"
                  hide-default-footer
                >
                  <template v-slot:[`item.price`]="{ item }">
                    <span class="price-badge"
                      >{{ item.price }} {{ item.currency || "EGP" }}</span
                    >
                  </template>
                </v-data-table>
              </div>
            </div>

            <!-- Additions -->
            <div
              class="magic-table-section mt-5"
              v-if="allData.additions && allData.additions.length"
            >
              <div class="section-title">
                <i class="fal fa-plus-circle ml-2"></i> الإضافات
              </div>
              <div class="magic-table-wrapper">
                <v-data-table
                  class="elevation-0 magic-table"
                  :headers="headers2"
                  :items="allData.additions"
                  :loading="loading"
                  hide-default-footer
                >
                  <template v-slot:[`item.price`]="{ item }">
                    <span class="price-badge"
                      >{{ item.price }} {{ item.currency || "EGP" }}</span
                    >
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <base-model
      @closeModel="model_1.show_model = false"
      :show="model_1.show_model"
    >
      <div class="image">
        <img
          v-if="model_1.model_img_src"
          :src="model_1.model_img_src"
          alt="..."
        />
      </div>
    </base-model>
  </div>
</template>

<script>
import imageFalse from "@/assets/images/icons/logo.png";
export default {
  props: ["id"],
  components: {},
  data() {
    return {
      selectedColor: null,
      selectedSize: null,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.products.title"),
          disabled: false,
          href: "/products/show-all",
        },
        {
          text: "عرض",
          disabled: true,
          href: "",
        },
      ],
      // ========== Model
      model_1: {
        show_model: false,
        model_img_src: "",
      },
      //Data
      allData: null,
      products_details: null,
      c1: undefined,
      c2: undefined,
      loading: false,
      // ========== Table
      headers: [
        {
          text: " الاسم بالعربي",
          align: "center",
          value: "ar.name",
          sortable: false,
        },
        {
          text: "الاسم بالانجليزي",
          align: "center",
          value: "en.name",
          sortable: false,
        },
        {
          text: "السعر",
          align: "center",
          value: "price",
          sortable: false,
        },
      ],
      headers2: [
        {
          text: " الاسم بالعربي",
          align: "center",
          value: "ar.name",
          sortable: false,
        },
        {
          text: "الاسم بالانجليزي",
          align: "center",
          value: "en.name",
          sortable: false,
        },
        {
          text: "السعر",
          align: "center",
          value: "price",
          sortable: false,
        },
      ],
    };
  },

  computed: {},
  methods: {
    replaceImage(e) {
      e.target.src = imageFalse;
    },
    // img Model
    show_model_1(e) {
      this.model_1.model_img_src = e.target.src;
      this.model_1.show_model = true;
    },
    //Get Prosuct
    getProduct() {
      this.loading = true;
      this.$axios({
        method: "GET",
        url: `meal/${this.id}`,
      })
        .then((res) => {
          this.allData = res.data.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    // Start:: Sync Slider Behavior Method
    syncSliderBehavior(_, nextPosition) {
      if (this.$refs.c1) this.$refs.c1.goTo(nextPosition);
      if (this.$refs.c2) this.$refs.c2.goTo(nextPosition);
    },
    // End:: Sync Slider Behavior Method
  },
  // ======= hooks
  mounted() {
    this.c1 = this.$refs.c1;
    this.c2 = this.$refs.c2;
    this.getProduct();
  },
};
</script>

<style lang="scss" scoped>
/* Magic Page Styles */
.product-details-magic-page {
  animation: fadeIn 0.8s ease-out forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Image Showcase */
.magic-image-showcase {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  background: radial-gradient(
    circle,
    rgba(133, 80, 129, 0.08) 0%,
    transparent 70%
  );
  border-radius: 40px;

  .glow-ring {
    position: absolute;
    width: 300px;
    height: 300px;
    border-radius: 50%;
    background: radial-gradient(
      circle,
      rgba(133, 80, 129, 0.15) 0%,
      transparent 60%
    );
    filter: blur(20px);
    z-index: 0;
    animation: pulse 4s infinite alternate;
  }

  .magic-slider {
    z-index: 1;
    width: 100%;
    max-width: 350px;
  }

  .magic-product-img {
    width: 100%;
    height: auto;
    object-fit: contain;
    border-radius: 30px;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
    transition: transform 0.5s ease;

    &:hover {
      transform: scale(1.05) translateY(-10px);
    }
  }
}

@keyframes pulse {
  0% {
    transform: scale(0.9);
    opacity: 0.7;
  }
  100% {
    transform: scale(1.1);
    opacity: 1;
  }
}

/* Header & Info */
.magic-info-wrapper {
  padding: 20px 0;
}

.magic-product-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 15px;

  .product-title {
    font-size: 2.2rem;
    font-weight: 800;
    color: #2c3e50;
    margin: 0;
    background: linear-gradient(45deg, var(--mainColor-2), #ff6b6b);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .magic-status-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 18px;
    border-radius: 30px;
    font-weight: bold;
    font-size: 1rem;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);

    &.status-active {
      background: rgba(46, 204, 113, 0.15);
      color: #27ae60;
      border: 1px solid rgba(46, 204, 113, 0.3);
    }
    &.status-inactive {
      background: rgba(231, 76, 60, 0.15);
      color: #c0392b;
      border: 1px solid rgba(231, 76, 60, 0.3);
    }
  }
}

/* Stats Grid */
.magic-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 15px;
}

.magic-stat-card {
  background: #fff;
  border-radius: 20px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.02);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.06);
    .stat-icon-wrapper {
      transform: scale(1.1) rotate(5deg);
    }
  }

  .stat-icon-wrapper {
    width: 50px;
    height: 50px;
    border-radius: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.4rem;
    color: white;
    flex-shrink: 0;
    transition: transform 0.4s ease;

    &.purple-gradient {
      background: linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%);
    }
    &.orange-gradient {
      background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
    }
    &.blue-gradient {
      background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
    }
  }

  .stat-content {
    .stat-label {
      font-size: 0.85rem;
      color: #888;
      font-weight: 600;
      display: block;
      margin-bottom: 4px;
    }
    .stat-value {
      font-size: 1.1rem;
      font-weight: 800;
      color: #333;
      margin: 0;
    }
  }
}

/* Desc Card */
.magic-desc-card {
  background: rgba(133, 80, 129, 0.03);
  border-radius: 20px;
  padding: 20px;
  border: 1px dashed rgba(133, 80, 129, 0.2);

  .desc-header {
    font-size: 1.1rem;
    font-weight: bold;
    color: var(--mainColor-2);
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }

  .desc-text {
    color: #555;
    line-height: 1.7;
    margin: 0;
    font-size: 0.95rem;
  }
}

/* Magic Tables */
.magic-table-section {
  .section-title {
    font-size: 1.2rem;
    font-weight: 800;
    color: #2c3e50;
    margin-bottom: 15px;
    display: flex;
    align-items: center;

    i {
      color: var(--mainColor-2);
    }
  }

  .magic-table-wrapper {
    background: white;
    border-radius: 20px;
    padding: 10px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
    border: 1px solid rgba(0, 0, 0, 0.02);

    .price-badge {
      background: rgba(46, 204, 113, 0.1);
      color: #27ae60;
      padding: 6px 12px;
      border-radius: 12px;
      font-weight: 800;
      font-family: "Inter", sans-serif;
    }
  }
}
</style>

<style lang="scss">
.product-details-magic-page {
  .v-data-table {
    border-radius: 15px !important;
    overflow: hidden;

    .v-data-table__wrapper tbody tr td {
      padding: 1rem !important;
      border-bottom: 1px dashed rgba(0, 0, 0, 0.05) !important;
    }

    thead th {
      background: rgba(133, 80, 129, 0.05) !important;
      color: var(--mainColor-2) !important;
      font-weight: 800 !important;
      font-size: 1.05rem !important;
      border-bottom: none !important;
    }

    tr:hover {
      transform: translateY(-2px) !important;
      background: rgba(0, 0, 0, 0.01) !important;
    }
  }
}
</style>
